import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";

import { onDocumentReady } from "./utils/document-ready";
import { lazyLoadComponent, loadComponent } from "./utils/loader";

import Menu from "./components/menu";

import { initGrantsDatabase } from "./components/grants-database";
import initSidenotes from "./components/sidenotes";
import { initResearchDatabase } from "./components/research-database";
import { initSiteSearch } from "./components/site-search";
import ImageSizes from "./components/image-sizes";

window.Alpine = Alpine;
Alpine.plugin([focus, collapse]);
initSidenotes(Alpine);
Alpine.start();

/**
 * Enable smooth scrolling only after the page has settled. Turning it on
 * immediately breaks the browser's native scroll-to-fragment on initial load:
 * it becomes an interruptible animation, and any late layout shift cancels or
 * truncates it (see css/app.css for the fuller explanation).
 */
window.addEventListener("load", () => {
  document.documentElement.classList.add("smooth-scroll");
});

onDocumentReady(() => {
  /**
   * Include the following components in the main bundle.
   */
  loadComponent(Menu, "#menu");
  loadComponent(ImageSizes, "img.js-image-sizes");

  /**
   * Lazy load the following components only when they are needed.
   */
  lazyLoadComponent(
    () => import("./components/collapsible"),
    ".js-collapsible",
  );

  import("./components/grant-table");

  // Import homepage-topper-animation to register the custom element
  // Don't use lazyLoadComponent - Web Components auto-instantiate when the tag is encountered
  import("./components/homepage-topper-animation");
  import("./components/cause-selection");
  // import("./components/grid-animation");
  lazyLoadComponent(() => import("./components/toc"), ".js-toc");
  lazyLoadComponent(() => import("./components/filters"), ".js-filters");
  if (document.getElementById("algolia-search-container")) {
    // Check for grants search container
    initGrantsDatabase(); // Call the function directly
  }
  if (document.getElementById("research-search")) {
    initResearchDatabase(); // Call the function directly
  }
  if (document.getElementById("algolia-site-search-container")) {
    initSiteSearch();
  }
  import("./components/toc");
  lazyLoadComponent(
    () => import("./components/grant-carousel"),
    ".js-featured-grants",
  );
  lazyLoadComponent(
    () => import("./components/card-carousel"),
    ".js-card-carousel",
  );
  lazyLoadComponent(
    () => import("./components/card-grid"),
    ".js-card-grid",
  );
  lazyLoadComponent(
    () => import("./components/video"),
    ".js-video",
  );
  lazyLoadComponent(
    () => import("./components/inline-video"),
    ".js-inline-video",
  );
  lazyLoadComponent(
    () => import("./components/hub-topper"),
    ".js-hub-topper",
  );
  lazyLoadComponent(
    () => import("./components/themed-topper"),
    ".js-themed-topper",
  );
  lazyLoadComponent(
    () => import("./components/sticky-subnav"),
    ".js-sticky-subnav",
  );
  lazyLoadComponent(
    () => import("./components/featured-funds"),
    ".js-featured-funds",
  );
});
